/**
 * @fileoverview Zod schemas for integration status API.
 * @module features/settings/schemas/integrationStatusSchema
 */

import { z } from 'zod'

/**
 * Integration provider types.
 */
export const IntegrationProviderSchema = z.enum([
  'FACEBOOK',
  'GOOGLE_ADS',
  'BASELINKER',
  'BANK',
  'SHOPIFY',
])

export type IntegrationProvider = z.infer<typeof IntegrationProviderSchema>

/**
 * Integration status types.
 */
export const IntegrationStatusTypeSchema = z.enum([
  'ACTIVE',
  'ERROR',
  'EXPIRED',
  'NOT_CONFIGURED',
])

export type IntegrationStatusType = z.infer<typeof IntegrationStatusTypeSchema>

/**
 * Schema for a single integration status.
 */
export const IntegrationStatusSchema = z.object({
  provider: IntegrationProviderSchema,
  status: IntegrationStatusTypeSchema,
  accountId: z.string().nullable(),
  accountName: z.string().nullable(),
  currency: z.string().nullable(),
  lastSyncedAt: z.string().nullable(),
  lastSyncError: z.string().nullable(),
  lastSyncRecordsCount: z.number().nullable(),
  consentValidUntil: z.string().nullable(),
  connectionId: z.string().uuid().nullable(),
})

export type IntegrationStatus = z.infer<typeof IntegrationStatusSchema>

/**
 * Schema for the full response (array of statuses).
 */
export const IntegrationStatusArraySchema = z.array(IntegrationStatusSchema)
